const TTL = {
  hour: 3600000,
  day: 86400000,
  week: 604800000,
  month: 2592000000,
  days: days => days * 86400000,
  months: months => months * 2592000000,
}

const clearCache = () => {
  return localStorage.removeItem('cache')
}

const getCacheKey = (name, params) => {
  return `cache_${name}_${btoa(JSON.stringify(params || {})).replace(/[+/=]/g, '')}`
}

const getCachedData = (name, params = {}, ttl = TTL.day) => {
  try {
    const key = getCacheKey(name, params)
    const cacheData = JSON.parse(localStorage.getItem('cache')) || {}

    if (!cacheData[key]) return null

    const { data, timestamp } = cacheData[key]

    if (Date.now() - timestamp < ttl) return data

    delete cacheData[key]
    localStorage.setItem('cache', JSON.stringify(cacheData))

    return null
  } catch {
    return null
  }
}

const setCachedData = (name, params = {}, data) => {
  try {
    const key = getCacheKey(name, params)
    const cacheData = JSON.parse(localStorage.getItem('cache')) || {}
    cacheData[key] = { data, timestamp: Date.now() }
    localStorage.setItem('cache', JSON.stringify(cacheData))
  } catch (e) {
    return e
  }
}

export {
  getCachedData,
  setCachedData,
  clearCache,
  TTL,
}
